import { ProfileName } from '../../profiles/profiles';
import { ProfilesActions } from '../storeActions';

export const setProfile = (name: ProfileName) => {
  return {
    type: ProfilesActions.SET_PROFILE,
    name: name
  };
};
